import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'sonner';

// Pages - Marketing
import LandingPage from './pages/LandingPage';
import HumanFirstPage from './pages/HumanFirstPage';
import A3AssessmentPage from './pages/A3AssessmentPage';
import A3ResultPage from './pages/A3ResultPage';
import AdminA3ResultsPage from './pages/admin/AdminA3ResultsPage';
import AdminEmailLogPage from './pages/admin/AdminEmailLogPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import PricingPage from './pages/PricingPage';
import MACResearchPage from './pages/MACResearchPage';
import GolferBenefitsPage from './pages/GolferBenefitsPage';
import MACMindfulPage from './pages/MACMindfulPage';
import MACAcceptingPage from './pages/MACAcceptingPage';
import MACCommitmentPage from './pages/MACCommitmentPage';
import MACAcceptanceVsResistancePage from './pages/MACAcceptanceVsResistancePage';
import ApproachPage from './pages/ApproachPage';
import ApproachBeforePage from './pages/ApproachBeforePage';
import ApproachDuringPage from './pages/ApproachDuringPage';
import ApproachInBetweenPage from './pages/ApproachInBetweenPage';
import ApproachAfterPage from './pages/ApproachAfterPage';
import SubscribeSuccessPage from './pages/SubscribeSuccessPage';
import SubscribeCancelPage from './pages/SubscribeCancelPage';
import FeaturesShowcasePage from './pages/FeaturesShowcasePage';
import ComingSoonDashboard from './pages/ComingSoonDashboard';
import LockerHome from './pages/locker/LockerHome';
import AwarenessLogPage from './pages/locker/AwarenessLogPage';
import AwarenessHistoryPage from './pages/locker/AwarenessHistoryPage';
import { AcceptanceLogPage, AcceptanceHistoryPage } from './pages/locker/AcceptancePages';
import { ActionLogPage, ActionHistoryPage } from './pages/locker/ActionPages';
import RoundReviewWizardPage from './pages/locker/RoundReviewWizardPage';
import RoundsHistoryPage from './pages/locker/RoundsHistoryPage';
import RoundReviewDetailPage from './pages/locker/RoundReviewDetailPage';
import TheGapPage from './pages/locker/TheGapPage';
import LockerProfilePage from './pages/locker/LockerProfilePage';
import LockerPaywallPage from './pages/locker/LockerPaywallPage';
import LockerSubscribeSuccessPage from './pages/locker/LockerSubscribeSuccessPage';
import SubscriptionGate from './components/SubscriptionGate';
import CoachLockerStudentsPage from './pages/coach/CoachLockerStudentsPage';
import CoachLockerStudentDetailPage from './pages/coach/CoachLockerStudentDetailPage';
import WelcomeIntroModal from './components/WelcomeIntroModal';

// Pages - Auth
import LoginPage from './pages/LoginPage';
import CoachLoginPage from './pages/CoachLoginPage';
import CoachBenefitsPage from './pages/CoachBenefitsPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SetPasswordPage from './pages/SetPasswordPage';
import ClaimSeatPage from './pages/ClaimSeatPage';
import ChoosePlanPage from './pages/ChoosePlanPage';

// Pages - Dashboard
import DashboardLayout from './pages/dashboard/DashboardLayout';
import DashboardOverview from './pages/dashboard/DashboardOverview';
import SessionsPage from './pages/dashboard/SessionsPage';
import GameStatsPage from './pages/dashboard/GameStatsPage';
import MyScorecardsPage from './pages/dashboard/MyScorecardsPage';
import RoundComparisonPage from './pages/dashboard/RoundComparisonPage';
import ShotgunPatternLogPage from './pages/dashboard/ShotgunPatternLogPage';
import PreRoundGoalsPage from './pages/dashboard/PreRoundGoalsPage';
import PostRoundReflectionsPage from './pages/dashboard/PostRoundReflectionsPage';
import PracticePlannerPage from './pages/dashboard/PracticePlannerPage';
import DiaryPage from './pages/dashboard/DiaryPage';
import ReportsPage from './pages/dashboard/ReportsPage';
import ShotgunPatternsReportPage from './pages/dashboard/ShotgunPatternsReportPage';
import ProgressPage from './pages/dashboard/ProgressPage';
import PressureResetPage from './pages/dashboard/PressureResetPage';
import LiveRoundPage from './pages/dashboard/LiveRoundPage';
import StrokesGainedExplainedPage from './pages/dashboard/StrokesGainedExplainedPage';
import YourLockerPage from './pages/dashboard/YourLockerPage';
import FAQPage from './pages/dashboard/FAQPage';
import ProfilePage from './pages/dashboard/ProfilePage';
import PendingApprovalPage from './pages/dashboard/PendingApprovalPage';
import TasksPage from './pages/dashboard/TasksPage';
import MessagesPage from './pages/dashboard/MessagesPage';
import SettingsPage from './pages/dashboard/SettingsPage';

// Pages - Pillars of Performance
import PillarsDashboard from './pages/dashboard/PillarsDashboard';
import MindsetPage from './pages/dashboard/pillars/MindsetPage';
import MovementPage from './pages/dashboard/pillars/MovementPage';
import NutritionPage from './pages/dashboard/pillars/NutritionPage';
import RecoveryPage from './pages/dashboard/pillars/RecoveryPage';

// Pages - Performance Scorecard
import ScorecardPage from './pages/dashboard/ScorecardPage';
import NewScorecardPage from './pages/dashboard/NewScorecardPage';
import ScorecardDetailPage from './pages/dashboard/ScorecardDetailPage';
import ScorecardAnalyticsPage from './pages/dashboard/ScorecardAnalyticsPage';

// Pages - Admin
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import ClientList from './pages/admin/ClientList';
import ClientDetail from './pages/admin/ClientDetail';
// InvitationsPage kept for redirect
import BlogManagementPage from './pages/admin/BlogManagementPage';
import TestimonialsManagementPage from './pages/admin/TestimonialsManagementPage';
import AdminMessagesPage from './pages/admin/MessagesPage';
import AdminCoaches from './pages/admin/AdminCoaches';
import AdminCoachDetail from './pages/admin/AdminCoachDetail';
import AdminTPIPage from './pages/admin/AdminTPIPage';
import NewsletterPage from './pages/admin/NewsletterPage';
import AdminCoachSubscriptionsPage from './pages/admin/AdminCoachSubscriptionsPage';

// Pages - Coach
import CoachLayout from './pages/coach/CoachLayout';
import CoachDashboard from './pages/coach/CoachDashboard';
import CoachClients from './pages/coach/CoachClients';
import CoachClientDetail from './pages/coach/CoachClientDetail';
import CoachInvitations from './pages/coach/CoachInvitations';
import CoachBulkPurchasePage from './pages/coach/CoachBulkPurchasePage';
import CoachBulkPurchaseSuccessPage from './pages/coach/CoachBulkPurchaseSuccessPage';
import CoachManageSeatsPage from './pages/coach/CoachManageSeatsPage';
import CoachDigestPage from './pages/coach/CoachDigestPage';
import CoachMessagesPage from './pages/coach/CoachMessagesPage';
import TPIScreeningForm from './pages/coach/TPIScreeningForm';
import CoachGroupsPage from './pages/coach/CoachGroupsPage';
import CoachReportsPage from './pages/coach/CoachReportsPage';
import CoachComparePage from './pages/coach/CoachComparePage';

// API Configuration — use relative path so it works on any domain (preview + production)
export const API = axios.create({
  baseURL: '/api',
});

// Auth Context
const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('qmg_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await API.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.error('Failed to fetch user:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await API.post('/auth/login', { email, password });
    const { access_token, user: userData } = response.data;
    localStorage.setItem('qmg_token', access_token);
    API.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const coachLogin = async (email, password) => {
    const response = await API.post('/auth/coach-login', { email, password });
    const { access_token, user: userData } = response.data;
    localStorage.setItem('qmg_token', access_token);
    API.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const register = async (data) => {
    const response = await API.post('/auth/register', data);
    const { access_token, user: userData } = response.data;
    localStorage.setItem('qmg_token', access_token);
    API.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('qmg_token');
    delete API.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(userData);
  };

  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';
  const isApproved = user?.status === 'approved' || isAdmin;

  return (
    <AuthContext.Provider value={{ user, token, loading, login, coachLogin, register, logout, updateUser, isAdmin, isApproved }}>
      {children}
    </AuthContext.Provider>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children, requireApproval = true }) => {
  const { user, loading, isApproved } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#2C5530] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#737373]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If approval required and user not approved, show pending page
  if (requireApproval && !isApproved) {
    return <Navigate to="/dashboard/pending" replace />;
  }

  return children;
};

// Admin Route Component
const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#2C5530] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#737373]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Auth Gate — any logged-in user (Free or Pro) can access
const AuthGate = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#2C5530] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#737373]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ gated: true }} />;
  }

  return children;
};

// Coach Route Component
const CoachRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#2C5530] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#737373]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!['coach', 'admin', 'superadmin'].includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <WelcomeIntroModal />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#FFFFFF',
              border: '1px solid #E7E5E4',
              color: '#1A1A1A',
            },
          }}
        />
        <Routes>
          {/* Marketing Pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/human-first" element={<HumanFirstPage />} />
          <Route path="/a3-assessment" element={<A3AssessmentPage />} />
          <Route path="/a3-assessment/result/:id" element={<A3ResultPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/pricing" element={<Navigate to="/" replace />} />
          <Route path="/mac-research" element={<MACResearchPage />} />
          <Route path="/golfer-benefits" element={<GolferBenefitsPage />} />
          <Route path="/mac/mindful" element={<AuthGate><MACMindfulPage /></AuthGate>} />
          <Route path="/mac/accepting" element={<AuthGate><MACAcceptingPage /></AuthGate>} />
          <Route path="/mac/commitment" element={<AuthGate><MACCommitmentPage /></AuthGate>} />
          <Route path="/mac/acceptance-vs-resistance" element={<AuthGate><MACAcceptanceVsResistancePage /></AuthGate>} />
          <Route path="/the-approach" element={<ApproachPage />} />
          <Route path="/the-approach/before" element={<AuthGate><ApproachBeforePage /></AuthGate>} />
          <Route path="/the-approach/during" element={<AuthGate><ApproachDuringPage /></AuthGate>} />
          <Route path="/the-approach/in-between" element={<AuthGate><ApproachInBetweenPage /></AuthGate>} />
          <Route path="/the-approach/after" element={<AuthGate><ApproachAfterPage /></AuthGate>} />
          <Route path="/subscribe-success" element={<Navigate to="/" replace />} />
          <Route path="/subscribe-cancel" element={<Navigate to="/" replace />} />
          <Route path="/features" element={<FeaturesShowcasePage />} />
          
          {/* Auth Pages */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/coach-login" element={<CoachLoginPage />} />
          <Route path="/coach-benefits" element={<CoachBenefitsPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route path="/claim-seat" element={<ClaimSeatPage />} />
          <Route path="/choose-plan" element={<Navigate to="/the-approach" replace />} />
          
          {/* Pending Approval - No approval required */}
          <Route path="/dashboard/pending" element={
            <ProtectedRoute requireApproval={false}>
              <PendingApprovalPage />
            </ProtectedRoute>
          } />
          
          {/* Dashboard (Protected) — Coming Soon while we re-evaluate the experience */}
          <Route path="/dashboard" element={
            <ProtectedRoute requireApproval={false}>
              <ComingSoonDashboard portalType="client" />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/*" element={
            <ProtectedRoute requireApproval={false}>
              <ComingSoonDashboard portalType="client" />
            </ProtectedRoute>
          } />

          {/* Player's Locker — Awareness module (gated behind subscription/trial) */}
          <Route path="/locker/paywall" element={
            <ProtectedRoute requireApproval={false}>
              <LockerPaywallPage />
            </ProtectedRoute>
          } />
          <Route path="/locker/subscribe/success" element={
            <ProtectedRoute requireApproval={false}>
              <LockerSubscribeSuccessPage />
            </ProtectedRoute>
          } />
          <Route path="/locker" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><LockerHome /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/awareness" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><AwarenessHistoryPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/awareness/new" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><AwarenessLogPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/acceptance" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><AcceptanceHistoryPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/acceptance/new" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><AcceptanceLogPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/action" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><ActionHistoryPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/action/new" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><ActionLogPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/round/new" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><RoundReviewWizardPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/rounds" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><RoundsHistoryPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/rounds/:id" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><RoundReviewDetailPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/gap" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><TheGapPage /></SubscriptionGate>
            </ProtectedRoute>
          } />
          <Route path="/locker/profile" element={
            <ProtectedRoute requireApproval={false}>
              <SubscriptionGate><LockerProfilePage /></SubscriptionGate>
            </ProtectedRoute>
          } />

          {/* Coach Locker view */}
          <Route path="/coach/locker" element={
            <CoachRoute><CoachLockerStudentsPage /></CoachRoute>
          } />
          <Route path="/coach/locker/:studentId" element={
            <CoachRoute><CoachLockerStudentDetailPage /></CoachRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="clients" element={<ClientList />} />
            <Route path="clients/:clientId" element={<ClientDetail />} />
            <Route path="coaches" element={<AdminCoaches />} />
            <Route path="coaches/:coachId" element={<AdminCoachDetail />} />
            <Route path="coach-subscriptions" element={<AdminCoachSubscriptionsPage />} />
            <Route path="tpi" element={<AdminTPIPage />} />
            <Route path="a3-results" element={<AdminA3ResultsPage />} />
            <Route path="email-log" element={<AdminEmailLogPage />} />
            <Route path="invitations" element={<Navigate to="/admin/clients" replace />} />
            <Route path="newsletter" element={<NewsletterPage />} />
            <Route path="blog" element={<BlogManagementPage />} />
            <Route path="testimonials" element={<TestimonialsManagementPage />} />
            <Route path="messages" element={<AdminMessagesPage />} />
          </Route>
          
          {/* Coach Routes — Coming Soon while we re-evaluate the experience */}
          <Route path="/coach" element={
            <CoachRoute>
              <ComingSoonDashboard portalType="coach" />
            </CoachRoute>
          } />
          <Route path="/coach/*" element={
            <CoachRoute>
              <ComingSoonDashboard portalType="coach" />
            </CoachRoute>
          } />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
App;
